import { Box, Container, Typography, Divider, styled } from '@mui/material';

export const StyledContainer = styled(Container)(({ theme }) => ({
  backgroundColor: 'transparent'
}));

export const StyledFormContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(10),
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[1]
}));

export const StyledGoogleButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3)
}));

export const StyledDividerContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  marginBottom: theme.spacing(3),
  textAlign: 'center'
}));

export const StyledDividerText = styled(Typography)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  backgroundColor: theme.palette.background.paper,
  padding: `0 ${theme.spacing(1)}`,
  color: theme.palette.text.secondary
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: 0,
  right: 0,
  zIndex: 0
}));

export const StyledForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));

export const StyledLoginLink = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline'
  }
})); 